import React, { useState, useEffect } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { Pricing } from './components/Pricing';
import { Certificates } from './components/Certificates';
import { About } from './components/About';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { CookieConsent } from './components/CookieConsent';
import { SiteData } from './types/data';

function App() {
  const [data, setData] = useState<SiteData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetch('./data.json')
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to load content configuration');
        }
        return response.json();
      })
      .then(data => {
        setData(data);
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setError(err.message);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (error || !data) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white text-red-500">
        <p>Error loading site content: {error}</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white font-sans text-slate-900">
      <Header data={data.header} />
      <main>
        <Hero data={data.hero} phone={data.header.phones[0]} />
        <Services data={data.services} />
        <Pricing data={data.pricing} />
        <Certificates data={data.certificates} />
        <About data={data.about} />
        <Contact data={data.contact} />
      </main>
      <Footer data={data.footer} title={data.header.title} subtitle={data.header.subtitle} />
      <CookieConsent data={data.cookieConsent} />
    </div>
  );
}

export default App;
